/*************************USER************************************/
export const USER_AUTH = "USER_AUTH";

/************************DRUGGIST*********************************/
export const SELECT_DRUGGIST = "SELECT_DRUGGIST";
export const REMOVE_DRUGGIST = "REMOVE_DRUGGIST";
